import { Box, Heading, Text, useToken } from '@chakra-ui/react';

import { ContentContainer } from '~/components/container';

export type BlurbSectionProps = {
  title: string;
  blurb: string;
};

export function BlurbSection({ title, blurb }: BlurbSectionProps) {
  const [containerWidth] = useToken('sizes', ['content-max-width']);

  return (
    <Box
      as='section'
      bgColor='white'
      position='relative'
      padding={{
        base: '40px 0px',
        xl: '80px 0px',
      }}
    >
      <ContentContainer
        textAlign='center'
        sx={{
          '&::after': {
            content: "''",
            display: 'block',
            borderTop: '1px solid',
            borderColor: 'accent.sea-foam.100',
            position: 'absolute',
            left: '50%',
            maxWidth: containerWidth,
            width: '100%',
            bottom: 0,
            transform: `translateX(-50%)`,
          },
        }}
      >
        <Box margin='0 auto' maxWidth='944px'>
          <Heading
            as='h2'
            mb={4}
            size={{
              base: 'marketing-xl',
              xl: 'marketing-2xl',
            }}
          >
            {title}
          </Heading>
          <Text>{blurb}</Text>
        </Box>
      </ContentContainer>
    </Box>
  );
}
